import { render, staticRenderFns } from "./PromotionAddPosPrice.vue?vue&type=template&id=72cc0579&scoped=true&"
import script from "./PromotionAddPosPrice.vue?vue&type=script&lang=js&"
export * from "./PromotionAddPosPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc0579",
  null
  
)

export default component.exports